module.exports = __webpack_public_path__ + "static/media/45.141f483c.jpg";